import { render, staticRenderFns } from "./CountriesPage.vue?vue&type=template&id=28376f6f&scoped=true"
import script from "./CountriesPage.vue?vue&type=script&lang=ts"
export * from "./CountriesPage.vue?vue&type=script&lang=ts"
import style0 from "./CountriesPage.vue?vue&type=style&index=0&id=28376f6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28376f6f",
  null
  
)

export default component.exports